import { createRoot } from "react-dom/client";
import { App } from "./app";
import { AuthProvider } from "@/guards/auth/auth-provider";
import { SessionTimeout } from "@/components/session-timeout";
import { BASE_NAME } from "@/constants";
import { msalInstance } from "@/guards/auth/auth-config";
import { getApplicationRoot, logger } from "@/utils";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalProvider,
} from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import { MisConfiguredPage } from "@/pages";
import { appConfig } from "@/guards/auth/azure-b2c.config";
import { ConfigValidationGuard } from "@/pages/config-validation/config-validation-guard";
import { reportWebVitals } from "@/services";
import { noop } from "lodash";

const container = getApplicationRoot();
const root = createRoot(container);

root.render(
  <ConfigValidationGuard>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <AuthenticatedTemplate>
          <BrowserRouter basename={BASE_NAME}>
            <App />
          </BrowserRouter>
          <SessionTimeout />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <MisConfiguredPage />
        </UnauthenticatedTemplate>
      </AuthProvider>
    </MsalProvider>
  </ConfigValidationGuard>,
);

// eslint-disable-next-line
reportWebVitals(
  Number(appConfig?.FEATURES?.IS_STATISTICS) ? logger.log : () => noop,
);
